export const iconFontAwesomeConnectivityTowerCell = (
	<i className="fa-solid fa-tower-cell"></i>
);
